import React from "react";
import Router from "./Router";
import { createTheme, ThemeProvider } from "@mui/material";
import { InfoSnackbarProvider } from "./lib/bandung/contexts/InfoSnackbarContext";

const themeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#b7adcf",
    },
    secondary: {
      main: "#FFFFF7",
    },
  },
  typography: {
    fontFamily: "Inter",
    fontColor: "black",
  },
};

const theme = createTheme(themeOptions);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <InfoSnackbarProvider>
        <Router />
      </InfoSnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
